document.addEventListener("DOMContentLoaded", function () {
  let currentUrl = window.location.href;
  const observer = new MutationObserver(() => {
    if (window.location.href !== currentUrl) {
      currentUrl = window.location.href;
      // setTimeout(() => {
      //   window.location.reload();
      // }, 50);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
document.addEventListener("click", function (e) {
  const button = e.target.closest(".quantity__button");
  if (!button) return;

  const quantityEl = button.closest("quantity-input");
  const input = quantityEl.querySelector(".quantity__input");
  const step = parseInt(input.step || 1);
  const min = parseInt(input.min || 1);
  const max = input.max ? parseInt(input.max) : null;

  let value = parseInt(input.value || min);

  if (button.name === "plus") {
    value += step;
    if (max !== null && value > max) value = max;
  } else if (button.name === "minus") {
    value -= step;
    if (value < min) value = min;
  }

  input.value = value;

  input.dispatchEvent(new Event("change", { bubbles: true }));
});


document.addEventListener('DOMContentLoaded', function () {
    const toggleIcon = document.getElementById('ip-toggle-icon');
    const navMenu = document.querySelector('nav.header__inline-menu');
    if (toggleIcon && navMenu) {
      toggleIcon.addEventListener('click', function () {
        navMenu.classList.toggle('hide');
      });
    }
  });



  document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('.custom-product-tab');
  const contents = document.querySelectorAll('.custom-product-tabs-desc');
  function deactivateAll() {
    tabs.forEach(tab => tab.classList.remove('active'));
    contents.forEach(content => content.style.display = 'none');
  }
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', function () {
      deactivateAll();
      tab.classList.add('active');
      if (contents[index]) {
        contents[index].style.display = 'block';
      }
    });
  });
  if (tabs.length && contents.length) {
    tabs[0].classList.add('active');
    contents[0].style.display = 'block';
  }
});

/***********************************************************************/
